module.exports = __webpack_public_path__ + "static/media/account ledger.16215c28.svg";